module.exports = __webpack_public_path__ + "img/logo.568e3cc6.png";